<template>
	<div class="g_nta">
		<div class="train__info">
			<div class="train__item" uk-tooltip="Шаг">
				<div class="train__ico train__ico--1"></div>
				<small>Шаг:</small>
				{{ local_steps }}
			</div>
			<div class="train__item" uk-tooltip="Ошибок сделано">
				<div class="train__ico train__ico--2"></div>
				<small>Ошибок:</small>
				{{ errors }}
			</div>
			<div class="train__item" v-if="$route.params.isHomework" uk-tooltip="Выполнено">
				<div class="train__ico train__ico--4"></div>
				<small>Выполнено:</small>
				<div class="train__nowrap">{{ $route.params.total }} из {{ $route.params.qnt }}</div>
			</div>
			<div class="train__item" uk-tooltip="Времени прошло">
				<div class="train__ico train__ico--3"></div>
				<span><small>Времени прошло:</small>
					{{ timer.minutes }}:{{ timer.seconds }}</span>
			</div>
		</div>

		<div v-if="mode === 'fight' && !preStart" class="uk-margin-top">
			<button class="uk-button uk-button-primary" @click="onStart">СТАРТ!</button>
		</div>

		<div v-show="preStart && !local_finish">
			<div class="atn__wrap">
				<div class="showed_number" :class="'showed_number-' + inkey">
					<h3 class="abacus__sum abacus__sum--big">Наберите<br> на абакусе<br> число: <span>{{ currentNumber }}</span>
					</h3>
				</div>
				<abacus
					:can-change="true"
					:axis-qnt="qnt"
					:show-clear="false"
					:show-sum="false"
					:show-numbers="false"
					:abacus-value="reset"
					@axisSum="setUserValue"
				></abacus>
			</div>
			<div v-if="is_error" class="flash__message flash__error">Неправильно! <span v-html="result"></span></div>
			<div v-if="is_success" class="flash__message flash__success">Правильно! <span v-html="result"></span></div>
			<!--<div class="flash__inp">
				<input type="text" class="uk-input" v-model="userNumber" placeholder="Введите число">
			</div>-->

			<p v-if="result">
				<strong>Ваш результат:</strong><br>
				<span v-html="result"></span>
				<span class="mental__checks" :class="(+userNumber === currentNumber) ? '' : 'active'"></span>
			</p>

			<div v-if="!readyNext">
				<button class="uk-button uk-button-primary" @click="nextStep">Ответить</button>
			</div>
			<div v-if="readyNext">
				<button :id="'next-' + inkey" class="uk-button uk-button-primary" @click="restart" v-if="!checkHomeworkFinish()">Дальше</button>
				<button class="uk-button uk-button-primary" @click="onStopTrainer" v-else>Закончить</button>
			</div>
		</div>
		<div v-if="local_finish" class="uk-margin-top">
			<p>Ваши результаты:</p>
			<div v-for="(result, key) in results" :key="result.id">
				<p><strong>Шаг: {{ key+1 }}: </strong>
					<span>Число: {{ result.cifers }}</span>, Ваш ответ: {{ result.user_answer }}
					<span class="mental__checks" :class="(+result.user_answer === result.cifers) ? '' : 'active'"></span></p>
			</div>
			<p class="scores">Ты зарабатываешь
				<strong>{{ scores }}</strong> {{ $root.getNoun(scores, 'балл', 'балла', 'баллов') }}!</p>
			<button class="uk-button uk-button-primary" @click="fullRestart">Повторим?</button>
		</div>
	</div>
</template>

<script>
  import abacus from "../abacus/abacus";
  import { mix } from './../mixin'
  import { flashmix } from './flash-mixin'

  export default {
    name: "nta",
    mixins: [
      mix, flashmix
    ],
    components: {
      abacus
    },
    data() {
      return {}
    },
    methods: {


      setUserValue(val) {
        this.userNumber = val;
      },
      nextStep() {
        if (this.userNumber) {
          this.checkError();
          let app = this;
          this.reset = '';
          /*setTimeout(function () {
            app.restart();
          }, 1000);*/
          this.finish = true;
          this.readyNext = true;
          this.$parent.startReaction(this.currentNumber, this.userNumber);

          let result = {
            cifers: this.currentNumber,
            user_answer: +this.userNumber,
            timer: this.timer
          };
          this.results.push(result);
          this.local_results.push(result);


          if (this.counter === +this.params.qnt) {
            console.log('Конец игры');
            this.local_finish = true;

            this.addScores();
            if (this.local_steps > 1 && this.stat_id) {
              this.updateStats();
            } else {
              this.makeStats();
            }

          } else {
            console.log('Следующий шаг');
          }
        }
      },
      restart() {
        if (this.checkFinishHomework()) {
          this.onStopTrainer();
        } else {
          if (!this.params.show_reactions) {
            this.$parent.scroll();
          }
          if (!this.local_finish && this.readyNext) {
            this.preStart = true;
            this.readyNext = false;
            this.result = '';
            this.reset = '';
            this.counter++;
            this.local_steps++;
            this.generateNumber();
            this.reset = 0;
            this.userNumber = '';
          } else if (!this.readyNext) {
            this.nextStep();
          } else {
            this.fullRestart();
          }
        }
      },
      generateNumber() {
        $('.showed_number-' + this.inkey).css('visibility', 'visible');
        //let from = +this.params.from;
        //let from = 1;
        let from = _.fill(new Array(+this.params.to), 0);
        from[0] = 1;
        from = Number(_.join(from, ''));
        let dt = (typeof this.params.direct_to !== 'undefined') ? +this.params.direct_to : 9;
        let direct_to = +this.params.to == 1 ? dt : 9;
        let to = Number(_.join(_.fill(new Array(+this.params.to), direct_to), ''));
        let number = this.randomInteger(from, to);
        //console.log('From to', from, to);
        this.currentNumber = number;
        this.speedy();
        console.log(number);
      },
    },
    mounted() {
      if (this.mode === 'fight') {
        this.preStart = false;
        $('#start-' + this.inkey).focus();
      } else {
        this.onStart();
      }
      this.$root.$on('fullCheck', () => {
        console.log('ss')
        if (!this.finish) {
          this.nextStep()
        }
      });
      this.$root.$on('fullStart', this.restart);
    },
    beforeDestroy() {
      this.$root.$off('fullCheck', this.nextStep);
      this.$root.$off('fullStart', this.restart);
    }
  }
</script>

<style lang="scss" scoped>
@media (max-width: 640px) {
  .atn__wrap {
  flex-direction: column;
  }
}
</style>